import { jsx } from "react/jsx-runtime";
import Editor$1 from "../Default/Editor.js";
import "../Default/Renderer.js";
const Editor = (props) => {
  return /* @__PURE__ */ jsx(Editor$1, { ...props, number: true });
};
export {
  Editor as default
};
